import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";

import ForgotPassword from "./Components/Auth/ForgotPassword";
import ResetPassword from "./Components/Auth/ResetPassword";
import SetPassword from "./Components/Auth/SetPassword";
import SignIn from "./Components/Auth/SignIn";
import AppLayout from "./Components/Layout/AppLayout";
import {
  UnAuthenticatedRoute,
  AuthenticatedRoute,
  PlatformAuthenticatedRoute,
  StudyAuthenticatedRoute,
} from "./utils/Route";

import Studies from "./Components/Studies/Studies";
// import Survey from "./Components/Survey/Survey";
import ChangePassword from "./Components/Auth/ChangePassword";
import Error404 from "./Components/Layout/404";
// import CustomSignIn from "./Components/Auth/CustomSignIn";
// import WelcomePage from "./Components/Survey/WelcomePage";
// import ThankYouPage from "./Components/Survey/ThankYouPage";
import SurveyWrapper from "./Components/Survey/SurveyWrapper";
import ThankYouWrapper from "./Components/Survey/ThankYouWrapper";
import QuestionPrintPhase from "./Components/QuestionBuilder/QuestionPrint/QuestionPrintPhase";
import QuestionPrintForm from "./Components/QuestionBuilder/QuestionPrint/QuestionPrintForm";
// import Organisations from "./Components/Organisations/Organisations";
// import CreateOrganisation from "./Components/Organisations/CreateOrganisation";
// import ViewOrganisation from "./Components/Organisations/ViewOrganisation/ViewOrganisation";
import Features from "./Components/Features/Features";
import OrganisationSettings from "./Components/OrganisationAdmin/Settings/Settings";
// import OrganisationUsers from "./Components/OrganisationAdmin/Users/Users";
// import OrganisationUserDetails from "./Components/OrganisationAdmin/Users/OrganisationUserDetails";
import OTPVerification from "./Components/Auth/OTPVerification";
// import UserRegistration from "./Components/Auth/UserRegistration";
import PlatformUsers from "./Components/Platform/Users/Users";
import PlatformUserProfile from "./Components/Platform/Users/UserProfile";
import { permissions, platformAdminPermissions } from "./utils/roles";
import PrintResponse from "./Components/Survey/PrintResponse/PrintResponse";
import FormResponsePrint from "./Components/Responses/PrintResponse/FormResponsePrint";
import Instruments from "./Components/Platform/Instruments/Instruments";
import AllStudies from "./Components/Studies/AllStudies";
import PlatformConfigTabs from "./Components/PlatformFeatures/PlatformConfigTabs";
// import { ParticipantJoinCode } from "./Routes/ParticipantsRoutes";
import Home from "./Home";
// import LinkParticipant from "./LinkParticipant";
// import WebviewWrapper from "./Components/CMS/Webview/WebviewWrapper";
// import LandingPage from "./Components/LandingPage/LandingPage";
// import Screening from "./Components/Screening/Screening";
import ThankYou from "./Components/Screening/ThankYou";
import Participants from "./Components/PlatformParticipant/Participants";
import GlobalParticipantTabs from "./Components/PlatformParticipant/GlobalParticipantTabs";
import PlatformDashboard from "./Components/Dashboard/PlatformDashboard/PlatformDashboard";
import AllSites from "./Components/Sites/AllSites";
import PlatformAuditTrail from "./Components/AuditTrail/PlatformAuditTrail";
import GlobalTags from "./Components/Tags/GlobalTags";
import CanonicalQuestions from "./Components/CanonicalQuestions/CanonicalQuestions";
import EmailTemplatesList from "./Components/EmailTemplates/EmailTemplatesList";
import PlatformSettings from "./Components/PlatformSettings/PlatformSettings";
import PlatformScreener from "./Components/PlatformDesigner/Screener/PlatformScreener";
import UserSettings from "./Components/UserSettings/UserSettings";
import RegistryConsentBuilder from "./Components/EConsent/RegistryConsentBuilder";
import RegistryConsentPreview from "./Components/EConsent/RegistryConsentPreview";
import RegistryFormPreview from "./Components/QuestionBuilder/RegistryFormPreview";
import RegistryFormBuilder from "./Components/QuestionBuilder/RegistryFormBuilder";
import RegistryFormTranslationBuilder from "./Components/QuestionBuilder/Translation/RegistryFormTranslationBuilder";
import Sponsors from "./Components/PlatformSponsors/Sponsors";
import RegistryCompareResponsesWrapper from "./Components/PlatformParticipant/RegistryCompareResponsesWrapper";
import RegistryConsentForm from "./Components/ParticipantRecords/ParticipantDetails/ConsentForms/ProviderSignature/ConsentForm/RegistryConsentForm";
import StudyLayout from "./Components/Layout/StudyLayout";
import DashboardV2 from "./Components/Dashboard/DashboardV2";
import StudyDesigner from "./Components/StudyDesigner/StudyDesigner";
import StudyFormBuilder from "./Components/QuestionBuilder/StudyFormBuilder";
import StudyFormTranslationBuilder from "./Components/QuestionBuilder/Translation/StudyFormTranslationBuilder";
import StudyFormPreview from "./Components/QuestionBuilder/StudyFormPreview";
import Records from "./Components/ParticipantRecords/Records";
import ParticipantTabs from "./Components/ParticipantRecords/ParticipantDetails/ParticipantTabs";
import { featuresMap } from "./utils/features";
import StudyConsentForm from "./Components/ParticipantRecords/ParticipantDetails/ConsentForms/ProviderSignature/ConsentForm/StudyConsentForm";
import Responses from "./Components/Responses/Responses";
import StudyCompareResponsesWrapper from "./Components/Responses/StudyCompareResponsesWrapper";
// import Stats from "./Components/Statistics/Stats";
// import Prescription from "./Components/ParticipantRecords/ParticipantDetails/Medication/Prescription/Prescription";
import ParticipantGroups from "./Components/ParticipantRecords/ParticipantGroups/ParticipantGroups";
import StudyConsentBuilder from "./Components/EConsent/StudyConsentBuilder";
import StudyConsentPreview from "./Components/EConsent/StudyConsentPreview";
import AuditTrail from "./Components/AuditTrail/AuditTrail";
import Export from "./Components/Export/Export";
import StudySettings from "./Components/StudySettings/StudySettings";
import Users from "./Components/AdminManagement/Users";
import UserDetail from "./Components/AdminManagement/UserDetail";
import FormPermissions from "./Components/AdminManagement/FormPermissions";
import RolesList from "./Components/AdminManagement/Roles/Roleslist";
import MaintenanceSchedule from "./Components/AdminManagement/MaintenanceSchedule";
import Queries from "./Components/QueryManagement/Queries";
import { participantTheme } from "./Components/ParticipantAuth/participantTheme";
import { ThemeProvider } from "@mui/material";
import ConsentForm from "./Components/ParticipantConsent/Sign/ConsentForm/ConsentForm";
import StudyCohortBuilder from "./Components/ParticipantRecords/ParticipantGroups/StudyCohortBuilder";
import CohortParticipants from "./Components/ParticipantRecords/ParticipantGroups/CohortParticipants";
import RegistryAppointments from "./Components/RegistryAppointments/RegistryAppointments";
import StudyAppointments from "./Components/StudyAppointments/StudyAppointments";
import ConsentTabs from "./Components/EConsent/ConsentTabs";
import PlatformConsentTabs from "./Components/PlatformDesigner/Econsent/PlatformConsentTabs";
import TrackerTabs from "./Components/ConsentsTracking/TrackerTabs";
import PlatformTrackerTabs from "./Components/ConsentsTracking/PlatformTrackerTabs";

const routes = createBrowserRouter([
  {
    path: "/auth",
    element: (
      <UnAuthenticatedRoute>
        <Outlet />
      </UnAuthenticatedRoute>
    ),
    children: [
      {
        path: "login",
        element: <SignIn />,
      },
      // {
      //   path: "login/:slug",
      //   element: <CustomSignIn />,
      // },
      // {
      //   path: "register/:slug",
      //   element: <UserRegistration />,
      // },
      {
        path: "forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "reset-password/:token",
        element: <ResetPassword />,
      },
      {
        path: "signup",
        element: <SetPassword />,
      },
      {
        path: "2fa",
        element: <OTPVerification />,
      },
      // {
      //   path: "participant/login",
      //   element: <ParticipantJoinCode />,
      // },
    ],
  },
  {
    path: "/profile/change-password",
    element: <ChangePassword />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/app",
    element: (
      <AuthenticatedRoute>
        <AppLayout />
      </AuthenticatedRoute>
    ),
    children: [
      {
        path: "dashboard",
        element: <PlatformDashboard />,
      },
      {
        path: "designer",
        children: [
          {
            index: true,
            element: <PlatformScreener />,
          },
          {
            path: "form/:formId/edit",
            element: <RegistryFormBuilder />,
          },
          {
            path: "form/:formId/edit-translation",
            element: <RegistryFormTranslationBuilder />,
          },
          {
            path: "form/:formId/preview",
            element: <RegistryFormPreview />,
          },
        ],
      },
      {
        path: "consent",
        children: [
          {
            index: true,
            element: <PlatformConsentTabs />,
          },
          {
            path: ":formId/edit",
            element: <RegistryConsentBuilder />,
          },
          {
            path: ":formId/preview",
            element: <RegistryConsentPreview />,
          },
        ],
      },
      {
        path: "tracker",
        element: <PlatformTrackerTabs />,
      },
      {
        path: "settings",
        element: <PlatformSettings />,
      },
      {
        path: "studies",
        element: <Studies />,
      },
      {
        path: "user-settings",
        element: <UserSettings />,
      },
      {
        path: "appointments",
        element: <RegistryAppointments />,
      },
      {
        path: "participants",
        children: [
          {
            index: true,
            element: <Participants />,
          },
          {
            path: ":participantId",
            element: <GlobalParticipantTabs />,
          },
          {
            path: ":participantId/responses/:formId/compare",
            element: <RegistryCompareResponsesWrapper />,
          },
          {
            path: ":participantId/consent-form/:consentId",
            element: <RegistryConsentForm />,
          },
        ],
      },
      // {
      //   path: "organisation",
      //   children: [
      //     {
      //       index: true,
      //       element: <Organisations />,
      //     },
      //     {
      //       path: "builder/:id",
      //       element: <CreateOrganisation />,
      //     },
      //     {
      //       path: "view/:id",
      //       element: <ViewOrganisation />,
      //     },
      //   ],
      // },
      {
        path: "features",
        element: (
          <PlatformAuthenticatedRoute
            action={platformAdminPermissions.managePlatform}
          >
            <Features />
          </PlatformAuthenticatedRoute>
        ),
      },
      {
        path: "settings/:id",
        element: <OrganisationSettings />,
      },
      // {
      //   path: "users",
      //   children: [
      //     {
      //       index: true,
      //       element: <OrganisationUsers />,
      //     },
      //     {
      //       path: "details/:id",
      //       element: <OrganisationUserDetails />,
      //     },
      //   ],
      // },
      {
        path: "platform-users",
        children: [
          {
            index: true,
            element: (
              <PlatformAuthenticatedRoute
                action={platformAdminPermissions.manageUser}
              >
                <PlatformUsers />
              </PlatformAuthenticatedRoute>
            ),
          },
          {
            path: ":userId",
            element: (
              <PlatformAuthenticatedRoute
                action={platformAdminPermissions.manageUser}
              >
                <PlatformUserProfile />
              </PlatformAuthenticatedRoute>
            ),
          },
        ],
      },
      {
        path: "audit-trail",
        element: <PlatformAuditTrail />,
      },
      {
        path: "all-studies",
        children: [
          {
            index: true,
            element: (
              <PlatformAuthenticatedRoute
                action={platformAdminPermissions.createStudy}
              >
                <AllStudies />
              </PlatformAuthenticatedRoute>
            ),
          },
          {
            path: "study/:id",
            element: (
              <PlatformAuthenticatedRoute
                action={platformAdminPermissions.createStudy}
              >
                <PlatformConfigTabs />
              </PlatformAuthenticatedRoute>
            ),
          },
        ],
      },

      {
        path: "templates",
        element: (
          <PlatformAuthenticatedRoute
          // action={platformAdminPermissions.viewPlatform}
          >
            <Instruments />
          </PlatformAuthenticatedRoute>
        ),
      },

      {
        path: "location",
        element: (
          <PlatformAuthenticatedRoute>
            <AllSites />
          </PlatformAuthenticatedRoute>
        ),
      },
      {
        path: "global-tags",
        element: (
          <PlatformAuthenticatedRoute>
            <GlobalTags />
          </PlatformAuthenticatedRoute>
        ),
      },
      {
        path: "canonical-questions",
        element: (
          <PlatformAuthenticatedRoute>
            <CanonicalQuestions />
          </PlatformAuthenticatedRoute>
        ),
      },
      {
        path: "email-templates",
        element: (
          <PlatformAuthenticatedRoute>
            <EmailTemplatesList />
          </PlatformAuthenticatedRoute>
        ),
      },
      {
        path: "sponsors",
        element: (
          <PlatformAuthenticatedRoute
          // action={platformAdminPermissions.viewPlatform}
          >
            <Sponsors />
          </PlatformAuthenticatedRoute>
        ),
      },
      {
        path: "maintenance-schedule",
        element: (
          <PlatformAuthenticatedRoute
            action={platformAdminPermissions.superManage}
          >
            <MaintenanceSchedule />
          </PlatformAuthenticatedRoute>
        ),
      },
    ],
  },
  {
    path: "surveys/:surveySlug",
    element: <SurveyWrapper />,
  },
  {
    path: "surveys/:surveySlug/thank-you",
    element: <ThankYouWrapper />,
  },
  {
    path: "404",
    element: <Error404 />,
  },
  {
    path: "thank-you",
    element: <ThankYou />,
  },
  {
    path: "print/study/:id/phase/:type",
    element: (
      <AuthenticatedRoute>
        <QuestionPrintPhase />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "print/study/:id/form/:formId",
    element: (
      <AuthenticatedRoute>
        <QuestionPrintForm />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "print/response",
    element: <PrintResponse />,
  },
  {
    path: "print/form-response",
    element: <FormResponsePrint />,
  },
  {
    path: "/studies/:id",
    element: (
      <AuthenticatedRoute>
        <StudyLayout />
      </AuthenticatedRoute>
    ),
    children: [
      {
        path: "dashboard",
        element: <DashboardV2 />,
      },
      {
        path: "study-designer",
        children: [
          {
            index: true,
            element: <StudyDesigner />,
          },
          {
            path: "form/:formId/edit",
            element: (
              <StudyAuthenticatedRoute action={permissions.studyDesigner}>
                <StudyFormBuilder />
              </StudyAuthenticatedRoute>
            ),
          },
          {
            path: "form/:formId/edit-translation",
            element: (
              <StudyAuthenticatedRoute action={permissions.studyDesigner}>
                <StudyFormTranslationBuilder />
              </StudyAuthenticatedRoute>
            ),
          },
          {
            path: "form/:formId/preview",
            element: (
              <StudyAuthenticatedRoute>
                <StudyFormPreview />
              </StudyAuthenticatedRoute>
            ),
          },
        ],
      },
      {
        path: "participants",
        children: [
          {
            index: true,
            element: (
              <StudyAuthenticatedRoute action={permissions.viewParticipant}>
                <Records />
              </StudyAuthenticatedRoute>
            ),
          },
          {
            path: ":participantId",
            children: [
              {
                path: "details",
                element: (
                  <StudyAuthenticatedRoute action={permissions.viewParticipant}>
                    <ParticipantTabs />
                  </StudyAuthenticatedRoute>
                ),
              },
              // {
              //   path: "timeline",
              //   lazy: async () => {
              //     const { ParticipantTimelineComp } = await import(
              //       "./Routes/StudyRoutes"
              //     );
              //     return { Component: ParticipantTimelineComp };
              //   },
              // },
              {
                path: "consent-form/:consentId",
                element: (
                  <StudyAuthenticatedRoute
                    feature={featuresMap.eConsent}
                    action={permissions.viewParticipant}
                  >
                    <StudyConsentForm />
                  </StudyAuthenticatedRoute>
                ),
              },
              {
                path: "responses",
                element: (
                  <StudyAuthenticatedRoute action={permissions.viewParticipant}>
                    <Responses />
                  </StudyAuthenticatedRoute>
                ),
              },
              {
                path: "responses/:formId/compare",
                element: (
                  <StudyAuthenticatedRoute action={permissions.viewParticipant}>
                    <StudyCompareResponsesWrapper />
                  </StudyAuthenticatedRoute>
                ),
              },
              // {
              //   path: "analysis",
              //   element: (
              //     <StudyAuthenticatedRoute feature={featuresMap.wearable}>
              //       <Stats />
              //     </StudyAuthenticatedRoute>
              //   ),
              // },
              // {
              //   path: "prescription",
              //   element: (
              //     <StudyAuthenticatedRoute feature={featuresMap.medication}>
              //       <Prescription />
              //     </StudyAuthenticatedRoute>
              //   ),
              // },
            ],
          },
        ],
      },
      {
        path: "participant-groups",
        children: [
          {
            index: true,
            element: (
              <StudyAuthenticatedRoute feature={featuresMap.participantGroups}>
                <ParticipantGroups />
              </StudyAuthenticatedRoute>
            ),
          },
          {
            path: ":groupId/filter",
            element: (
              <StudyAuthenticatedRoute feature={featuresMap.participantGroups}>
                <StudyCohortBuilder />
              </StudyAuthenticatedRoute>
            ),
          },
          {
            path: ":groupId/participants",
            element: (
              <StudyAuthenticatedRoute action={permissions.viewParticipant}>
                <CohortParticipants />
              </StudyAuthenticatedRoute>
            ),
          },
        ],
      },
      {
        path: "e-consent",
        children: [
          {
            index: true,
            element: (
              <StudyAuthenticatedRoute
                feature={featuresMap.eConsent}
                action={permissions.studyDesigner}
              >
                <ConsentTabs />
              </StudyAuthenticatedRoute>
            ),
          },
          {
            path: "form/:formId/edit",
            element: (
              <StudyAuthenticatedRoute
                feature={featuresMap.eConsent}
                action={permissions.studyDesigner}
              >
                <StudyConsentBuilder />
              </StudyAuthenticatedRoute>
            ),
          },

          {
            path: "form/:formId/preview",
            element: (
              <StudyAuthenticatedRoute
                feature={featuresMap.eConsent}
                action={permissions.studyDesigner}
              >
                <StudyConsentPreview />
              </StudyAuthenticatedRoute>
            ),
          },
          {
            path: "form/:formId/providerSign",
            element: (
              <StudyAuthenticatedRoute
                feature={featuresMap.eConsent}
                action={permissions.studyDesigner}
              >
                <StudyConsentPreview />
              </StudyAuthenticatedRoute>
            ),
          },
        ],
      },
      // {
      //   path: "medication",
      //   lazy: async () => {
      //     const { MedicationComp } = await import("./Routes/StudyRoutes");
      //     return { Component: MedicationComp };
      //   },
      // },
      {
        path: "audit-trail",
        element: (
          <StudyAuthenticatedRoute action={permissions.auditLogs}>
            <AuditTrail />
          </StudyAuthenticatedRoute>
        ),
      },
      {
        path: "export",
        element: (
          <StudyAuthenticatedRoute action={permissions.export}>
            <Export />
          </StudyAuthenticatedRoute>
        ),
      },
      {
        path: "tracker",
        element: (
          <StudyAuthenticatedRoute
            feature={featuresMap.eConsent}
            action={permissions.viewParticipant}
          >
            <TrackerTabs />
          </StudyAuthenticatedRoute>
        ),
      },
      // {
      //   path: "medication",
      //   lazy: async () => {
      //     const { MedicationComp } = await import("./Routes/StudyRoutes");
      //     return { Component: MedicationComp };
      //   },
      // },
      {
        path: "study-settings",
        element: (
          <StudyAuthenticatedRoute action={permissions.studySettings}>
            <StudySettings />
          </StudyAuthenticatedRoute>
        ),
      },
      // {
      //   path: "study-theme",
      //   lazy: async () => {
      //     const { StudyThemePanelComp } = await import("./Routes/StudyRoutes");
      //     return { Component: StudyThemePanelComp };
      //   },
      // },
      {
        path: "users",
        children: [
          {
            index: true,
            element: (
              <StudyAuthenticatedRoute action={permissions.userManagement}>
                <Users />
              </StudyAuthenticatedRoute>
            ),
          },
          {
            path: ":userId",
            element: (
              <StudyAuthenticatedRoute action={permissions.userManagement}>
                <UserDetail />
              </StudyAuthenticatedRoute>
            ),
          },
        ],
      },

      {
        path: "form-permissions",
        element: (
          <StudyAuthenticatedRoute action={permissions.userManagement}>
            <FormPermissions />
          </StudyAuthenticatedRoute>
        ),
      },
      {
        path: "permissions",
        element: (
          <StudyAuthenticatedRoute action={permissions.userManagement}>
            <RolesList />
          </StudyAuthenticatedRoute>
        ),
      },
      {
        path: "queries",
        element: (
          <StudyAuthenticatedRoute
            action={permissions.viewParticipant}
            feature={featuresMap.queries}
          >
            <Queries />
          </StudyAuthenticatedRoute>
        ),
      },
      // {
      //   path: "appointments",
      //   children: [
      //     {
      //       index: true,
      //       lazy: async () => {
      //         const { AppointmentsComp } = await import("./Routes/StudyRoutes");
      //         return { Component: AppointmentsComp };
      //       },
      //     },
      //     {
      //       path: "list",
      //       lazy: async () => {
      //         const { AppointmentListViewComp } = await import(
      //           "./Routes/StudyRoutes"
      //         );
      //         return { Component: AppointmentListViewComp };
      //       },
      //     },
      //   ],
      // },
      {
        path: "appointments",
        element: (
          <StudyAuthenticatedRoute action={permissions.viewAppointment}>
            <StudyAppointments />
          </StudyAuthenticatedRoute>
        ),
      },
      // {
      //   path: "my-availability",
      //   lazy: async () => {
      //     const { MyAvailabilityComp } = await import("./Routes/StudyRoutes");
      //     return { Component: MyAvailabilityComp };
      //   },
      // },

      // {
      //   path: "messages",
      //   lazy: async () => {
      //     const { MessagesComp } = await import("./Routes/StudyRoutes");
      //     return { Component: MessagesComp };
      //   },
      // },
      // {
      //   path: "exercise",
      //   children: [
      //     {
      //       index: true,
      //       lazy: async () => {
      //         const { ExerciseCollectionComp } = await import(
      //           "./Routes/StudyRoutes"
      //         );
      //         return { Component: ExerciseCollectionComp };
      //       },
      //     },
      //     {
      //       path: ":exerciseId/categories",
      //       lazy: async () => {
      //         const { ExerciseCollectionDetailsComp } = await import(
      //           "./Routes/StudyRoutes"
      //         );
      //         return { Component: ExerciseCollectionDetailsComp };
      //       },
      //     },
      //     {
      //       path: ":exerciseId/categories/:categoryId/sections",
      //       lazy: async () => {
      //         const { SectionBuilderComp } = await import(
      //           "./Routes/StudyRoutes"
      //         );
      //         return { Component: SectionBuilderComp };
      //       },
      //     },
      //     {
      //       path: "builder",
      //       lazy: async () => {
      //         const { ExerciseBuilderComp } = await import(
      //           "./Routes/StudyRoutes"
      //         );
      //         return { Component: ExerciseBuilderComp };
      //       },
      //     },
      //   ],
      // },
      // {
      //   path: "cms",
      //   children: [
      //     {
      //       index: true,
      //       lazy: async () => {
      //         const { CMSComp } = await import("./Routes/StudyRoutes");
      //         return { Component: CMSComp };
      //       },
      //     },
      //     {
      //       path: "learning/:categoryId",
      //       lazy: async () => {
      //         const { LearningModuleDetailsComp } = await import(
      //           "./Routes/StudyRoutes"
      //         );
      //         return { Component: LearningModuleDetailsComp };
      //       },
      //     },
      //     {
      //       path: ":moduleId",
      //       lazy: async () => {
      //         const { UnitsComp } = await import("./Routes/StudyRoutes");
      //         return { Component: UnitsComp };
      //       },
      //     },
      //     {
      //       path: "units/:moduleId",
      //       lazy: async () => {
      //         const { PagesComp } = await import("./Routes/StudyRoutes");
      //         return { Component: PagesComp };
      //       },
      //     },
      //     {
      //       path: "review/:moduleId",
      //       lazy: async () => {
      //         const { ReviewsComp } = await import("./Routes/StudyRoutes");
      //         return { Component: ReviewsComp };
      //       },
      //     },
      //     {
      //       path: "builder/:unitId",
      //       lazy: async () => {
      //         const { CMSBuilderComp } = await import("./Routes/StudyRoutes");
      //         return { Component: CMSBuilderComp };
      //       },
      //     },
      //     {
      //       path: "preview/:unitId",
      //       lazy: async () => {
      //         const { CMSPreviewWrapperComp } = await import(
      //           "./Routes/StudyRoutes"
      //         );
      //         return { Component: CMSPreviewWrapperComp };
      //       },
      //     },
      //   ],
      // },
    ],
  },
  // {
  //   path: "/study/:studySlug",
  //   element: <LandingPage />,
  // },
  // {
  //   path: "/participant",
  //   lazy: async () => {
  //     const { ParticipantLayoutComp } = await import(
  //       "./Routes/ParticipantsRoutes"
  //     );
  //     return { Component: ParticipantLayoutComp };
  //   },
  //   children: [
  //     {
  //       path: "home",
  //       lazy: async () => {
  //         const { HomeComp } = await import("./Routes/ParticipantsRoutes");
  //         return { Component: HomeComp };
  //       },
  //     },
  //     {
  //       path: "questionnaires",
  //       lazy: async () => {
  //         const { QuestionnaireComp } = await import(
  //           "./Routes/ParticipantsRoutes"
  //         );
  //         return { Component: QuestionnaireComp };
  //       },
  //     },
  //     {
  //       path: "questionnaires/:id/survey/:surveyId",
  //       lazy: async () => {
  //         const { SurveyComp } = await import("./Routes/ParticipantsRoutes");
  //         return { Component: SurveyComp };
  //       },
  //     },
  //     {
  //       path: "e-consent",
  //       children: [
  //         {
  //           index: true,
  //           lazy: async () => {
  //             const { EConsentComp } = await import(
  //               "./Routes/ParticipantsRoutes"
  //             );
  //             return { Component: EConsentComp };
  //           },
  //         },
  //       ],
  //     },
  //     {
  //       path: "appointments",
  //       lazy: async () => {
  //         const { ParticipantAppointmentsComp } = await import(
  //           "./Routes/ParticipantsRoutes"
  //         );
  //         return { Component: ParticipantAppointmentsComp };
  //       },
  //     },
  //   ],
  // },
  {
    path: "sign/:id",
    element: (
      <AuthenticatedRoute>
        <ThemeProvider theme={participantTheme}>
          <ConsentForm />
        </ThemeProvider>
      </AuthenticatedRoute>
    ),
  },
  // {
  //   path: "link/participant/redirect/:type",
  //   element: <LinkParticipant />,
  // },
  // {
  //   path: "/telehealth/:studyId/:apptId",
  //   lazy: async () => {
  //     const { OpenTokComp } = await import("./Routes/StudyRoutes");
  //     return { Component: OpenTokComp };
  //   },
  // },
  // {
  //   path: "/screening/:id",
  //   element: (
  //     <AuthenticatedRoute allowedRoles={["participant"]}>
  //       <Screening />
  //     </AuthenticatedRoute>
  //   ),
  // },
  // {
  //   path: "/lesson/read/:unitId",
  //   element: <WebviewWrapper />,
  // },
  {
    path: "/",
    element: <Navigate to="/home" replace />,
  },
  {
    path: "*",
    element: <Navigate to="/home" replace />,
  },
]);

export default routes;
